import React from 'react';
import KycRequirements from './kyc-requirements';
export default function GovernmentId() {
  return /*#__PURE__*/React.createElement(KycRequirements, {
    label: "Government ID",
    submitOne: true,
    list: ['Driver’s License', 'Unified Multi-Purpose ID (UMID) Card', 'Social Security System (SSS) card', 'Police Clearance', 'Professional Regulatory Commission (PRC) ID', 'NBI Clearance', 'PhilHealth ID', 'Tax Identification Number (TIN) Card', 'Philippine Passport (with signature on 3rd page)', 'Postal ID', 'Voter’s ID', 'National ID', 'Voter’s Certification']
  });
}
//# sourceMappingURL=government-id.js.map